import type { Entity as WorkbookEntity } from '~/@entities/(Content)/Workbook/dto'
import type { AllGradeSubject, Revision, SchoolType } from '~/@entities/SchoolSystem/schema'

import type { ProductType } from '../Product/type'

type Page = {
  page: number
  imageUrl: string
}

export namespace Entity {
  export class ProductDetail {
    id: number
    type: ProductType
    name: string
    description: string
    thumbnailImageUrl: string
    detailImageUrl: string
    workbookId: number
    problemColorPrice: number
    problemBwPrice: number
    problemPageCount: number
    problemAnswerColorPrice: number
    problemAnswerBwPrice: number
    problemAnswerPageCount: number
    productDiscountRate: number
    problemColorDiscountedPrice: number
    problemBwDiscountedPrice: number
    problemAnswerColorDiscountedPrice: number
    problemAnswerBwDiscountedPrice: number
    index: string
    revision: Revision
    schoolType: SchoolType
    grade: AllGradeSubject
    semester: 1 | 2 | null
    pairFlag: boolean
    autoScored: boolean
    signatureType: WorkbookEntity.CustomSignatureWorkbook['signatureType']
    pages: Page[]

    constructor(data: ProductDetail) {
      this.id = data.id
      this.type = data.type
      this.name = data.name
      this.description = data.description
      this.thumbnailImageUrl = data.thumbnailImageUrl
      this.detailImageUrl = data.detailImageUrl
      this.workbookId = data.workbookId
      this.problemColorPrice = data.problemColorPrice
      this.problemBwPrice = data.problemBwPrice
      this.problemPageCount = data.problemPageCount
      this.problemAnswerColorPrice = data.problemAnswerColorPrice
      this.problemAnswerBwPrice = data.problemAnswerBwPrice
      this.problemAnswerPageCount = data.problemAnswerPageCount
      this.productDiscountRate = data.productDiscountRate
      this.problemColorDiscountedPrice = data.problemColorDiscountedPrice
      this.problemBwDiscountedPrice = data.problemBwDiscountedPrice
      this.problemAnswerColorDiscountedPrice = data.problemAnswerColorDiscountedPrice
      this.problemAnswerBwDiscountedPrice = data.problemAnswerBwDiscountedPrice
      this.index = data.index
      this.revision = data.revision
      this.schoolType = data.schoolType
      this.grade = data.grade
      this.semester = data.semester
      this.pairFlag = data.pairFlag
      this.autoScored = data.autoScored
      this.signatureType = data.signatureType
      this.pages = data.pages
    }
  }
}
